// extracted by mini-css-extract-plugin
module.exports = {"faEye":"faEye--UIJsa","table":"table--3MGeP"};